import { Button, Notification, Select, Loader } from '@scuf/common';
import { getRmaStatus } from 'helpers';
import { blockedRmaStatus, statusOptions, RmaModel, RmaModelLite } from 'models';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilState } from 'recoil';
import { Rma, REPAIR_CENTER, RmaLite, COMPANY_MANAGER, notificationAtom, companyDTO } from 'resources';
import useFetch from 'helpers/hooks/useFetch';
import { CompanyDTO } from 'models/userManager/addCustomer';

interface ChangeStatusProps {
    rmaState: RmaModelLite;
    setRmaState: React.Dispatch<React.SetStateAction<RmaModelLite>>;
}

const ENV = process.env.NODE_ENV;
var emailQA = process.env.REACT_APP_REPAIR_CENTER_EMAIL;

function ChangeStatus({ rmaState, setRmaState }: ChangeStatusProps): JSX.Element {
    const statusList = statusOptions.filter(element => blockedRmaStatus.includes(element.value));
    const allStatusList = statusOptions;
    const [currentStatus, setCurrentStatus] = useState(getRmaStatus(rmaState.statusId));
    const { t } = useTranslation(['common']);

    const [updateStatus, changeStatusRmaByAdmin, loading] = useFetch<RmaModelLite>({
        url: REPAIR_CENTER.changeStatusRmaByAdmin,
        method: 'POST',
        onError: 'Change',
        onSuccess: 'Change'
    });


    const [_, sendUpdateStatusEmail, loadingStatusEmail] = useFetch<{ rmaId: number, statusId: any, email: string, cnpj: string }, { error: boolean, message: string }>({
        url: REPAIR_CENTER.updateStatusSendEmail,
        method: 'POST',
        onError: 'Change',
        onSuccess: 'Change',
    });

    const [responseCompany, getCompanyById, loadingCompany] = useFetch<{ id: number | undefined }, CompanyDTO>({
        url: COMPANY_MANAGER.getCompanyById,
        method: 'GET',
        onError: 'EmailError'
    });

    const changeRmaStatus = async (newRma: RmaModelLite): Promise<void> => {
        await changeStatusRmaByAdmin(newRma, current => {
            current.error
                ? setRmaState(old => ({ ...old, statusId: currentStatus!.value }))
                : setRmaState({
                    ...rmaState,
                    statusId: current.data.statusId,
                    status: { name: currentStatus?.text ?? '', id: currentStatus?.value ?? 0 }
                });
        });
    };

    return (
        (loadingStatusEmail == true) ? (<Loader text='Carregando' />) : (
            <div className="container-changes">
                <div className="container-selects">
                    <Select
                        className="select"
                        options={statusList}
                        disabled
                        label={t('translation.From')}
                        placeholder={allStatusList.find(e => e.value === rmaState?.statusId)?.text}
                    />
                    <Select
                        className="select"
                        indicator="required"
                        placeholder={t('placeholders.Select.NewValue')}
                        options={statusList}
                        label={t('translation.To')}
                        onChange={val => {
                            setCurrentStatus(getRmaStatus(val))
                            getCompanyById({ id: rmaState.companyId });
                        }}
                    />
                </div>
                <div className="container-button">
                    <Button
                        content={t('actions.Change')}
                        disabled={currentStatus?.value === rmaState.statusId}
                        loading={loading || loadingCompany || loadingStatusEmail}
                        onClick={async () => {
                            await sendUpdateStatusEmail({ rmaId: rmaState.id, statusId: currentStatus!.value, email: ENV === 'production' ? responseCompany?.data?.email! : emailQA!, cnpj: responseCompany?.data?.cnpj! });
                            setRmaState({ ...rmaState, statusId: currentStatus?.value! });
                        }}
                    />
                </div>
            </div>
        ));
}
export default ChangeStatus;
